<template>
  <footer class="app-footer">
    <span>{{tec}}</span>
  </footer>
</template>
<script>
export default {
  name: 'footer',
  props: ['tec'],
};
</script>
